import { render, staticRenderFns } from "./gc-popup-release-and-issue-bulk.vue?vue&type=template&id=44e04f34"
import script from "./gc-popup-release-and-issue-bulk.vue?vue&type=script&lang=js"
export * from "./gc-popup-release-and-issue-bulk.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-release-and-issue-bulk.vue?vue&type=style&index=0&id=44e04f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports